<template>
  <div class="container subscriber-block">
    <div class="subscriber">
      <div class="login" v-show="!isLogin">
        <div id="google-sign-in" class="g-signin-button"></div>
        <span class="hint">to subscribe/unsubscribe email</span>
      </div>
      <div v-show="isLogin">
        <div class="user-info">
          <img :src="userInfo.picture" class="picture">
          <span class="user-name">{{ userInfo.name }}</span>
          <a @click="logout">Logout</a>
        </div>
        <div>
            <span class="user-email">{{ userInfo.email }}</span>
        </div>
        <div>
          <a class="button is-danger is-outlined" v-if="isSubscribed" @click="unsubscribe">Unsubscribe</a>
          <a class="button is-success" v-else @click="subscribe">Subscribe</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriberBlock',
  props: {
    isSubscribed: {
      type: Boolean,
      default: false,
      required: true,
    },
    isLogin: {
      type: Boolean,
      default: false,
      required: true,
    },
    userInfo: {
      type: Object,
      default: Object,
      required: true,
    },
  },
  methods: {
    subscribe() {
      this.$emit('subscribe');
    },
    unsubscribe() {
      this.$emit('unsubscribe');
    },
    logout() {
      this.$emit('logout');
    },
  }
}
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.5/css/bulma.min.css";

.subscriber-block {
}

.subscriber {
  float: right;
  margin-top: -3rem;
  min-width: 14rem;
  @media screen and (max-width: 900px) {
    float: unset;
    margin-top: 2rem;
    display: block;
    height: 5rem;
  }
}

.user-info {
  display: flex;
  justify-content: center;
}

.picture {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 9999px;
}

.user-name {
  margin: 0 0.5rem 0 0.5rem;
}

.hint {
  font-size: 0.8rem;
  color: #777;
  text-align: left;
}
</style>
